import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";

import List from "./reporting list components/List";
import { useAxios, useComponent } from "../../hooks";
import { PageHeader, Pagination } from "../../components";

export default function Reporting() {
  const axios = useAxios();
  const { loader } = useComponent();

  const options = [5, 10, 25, 50, 100];
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [page, setPage] = useState({
    page: 1,
    totalCount: 0,
    lastCount: 0,
    itemsPerPage: 10,
  });

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/external/campaign/report?brand_id=" +
        activeBrand.ID +
        `&page=${page.page}&limit=${page.itemsPerPage}` +
        (searchKey ? `&search=${encodeURIComponent(searchKey)}` : ""),
    }).then((response) => {
      if (response.status) {
        if (response.data.resultedCampaign.length > 0) {
          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCounts,
            lastPage: response.data.resultedCampaign?.length < 10,
          }));

          setReports(response.data.resultedCampaign);
        } else {
          setReports([]);
        }
      }
      setLoading(false);
    });
  }, [axios, activeBrand.ID, loader, page.page, searchKey, page.itemsPerPage]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  const handleChange = (event) => {
    setPage((prev) => ({
      ...prev,
      itemsPerPage: event.target.value,
    }));
  };
  return (
    <Fragment>
      <PageHeader
        pageName={"Campaign Reports"}
        pageHeader="View performance summaries of all your campaigns in one place."
      />

      <List
        reports={reports}
        loading={loading}
        setPage={setPage}
        setSearchKey={setSearchKey}
        component=""
      />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"space-between"}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography variant="body1" fontWeight={600}>
              Items per page:
            </Typography>
            <TextField
              select
              size="small"
              value={page.itemsPerPage}
              onChange={handleChange}
              sx={{
                width: 80,
                "& .MuiOutlinedInput-input": {
                  textAlign: "center",
                },
              }}
            >
              {options.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>

          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(e, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
